export class CollisionResolutionWarehouseRefillModel {
    requestId: number;
    activityId: number;
    items: CollisionResolutionWarehouseRefillItem[] = [];
}

export class CollisionResolutionWarehouseRefillItem {
    serialNumber: string;
    nomenclature: string;
    deviceStatusId: number;
}